import { useEffect } from "react"
import { Link, useParams, useOutletContext, useNavigate } from "react-router-dom"

import useRedirectOnBeIdChange from '../../../hooks/useRedirectOnBeIdChange.js'
import { useComputed, useSignal } from "@preact/signals-react"

import Breadcrumb from 'react-bootstrap/Breadcrumb'
import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Table from 'react-bootstrap/Table'

import AdministrationTabs from '../components/AdministrationTabs'
import LoadingAnimation from '../../../components/LoadingAnimation'
import PageTitle from "../../../components/PageTitle.jsx"
import { NotificationTypes, addNotification } from "../../../state/actions/notificationActions"

import { fetchApplicationGroups } from '../../../state/actions/applicationGroupActions'
import { fetchRole, fetchRolePermissions } from '../../../state/actions/roleActions'

import { applicationGroupsSignal, applicationGroupsLoadedSignal } from '../../../state/signals/applicationGroupSignals'
import { roleSignal, roleLoadedSignal, rolePermissionsSignal, rolePermissionsLoadedSignal } from '../../../state/signals/roleSignals'

const RoleDetailPage = function () {

	const navigate = useNavigate()
	const { beId, roleId } = useParams()
	useRedirectOnBeIdChange(beId, `/be/${beId}/management/roles`)
	const { user, config, accessToken, userPermissions, userPermissionsSummary, accordionData: sidebarAccordionData } = useOutletContext()

	useEffect(() => {
		if (userPermissionsSummary.value && !userPermissionsSummary.value.canViewRoles) {
			addNotification('You are not authorized to view roles for this account.', NotificationTypes.ERROR, true)
			navigate(`/`)
		}
	}, [userPermissionsSummary.value, navigate])
	
	const canEditComputed = useComputed(
		() => {
			return userPermissionsSummary?.value?.canEditRoles
		}
	)

	useEffect(() => {
		fetchRole(roleId, config, accessToken)
		fetchApplicationGroups(config, accessToken)
		fetchRolePermissions(roleId, config, accessToken)
	}, [roleId, config, accessToken])

	const editingSignal = useSignal(false)
	const showEditSignal = useSignal(false)
	const showEditRoleModalSignal = useSignal(false)
	//XXX TODO I don't think this is a modal in the original ember, but I can't get it to display anyway
	const showEditRoleModal = () => {
		showEditRoleModalSignal.value = true
	}

	const ApplicationGroupPermissionRows = () => {
		/*if (!("permissions" in appGroup)) {
			return null
		}*/
		let rows = []
		for (let i = 0; i < rolePermissionsSignal.value.length; i++) {
			const permission = rolePermissionsSignal.value[i]
			rows.push(
				<tr key={permission.id}>
					<td style={{ width: '50%' }} >{permission.name}</td>
					<td style={{ width: '16%' }}>
						<div className='checkbox text-muted'>
							{
								permission.view && (
									<label>
										<input type="checkbox" disabled={!editingSignal.value} checked={permission.view} />
										&nbsp;View
									</label>
								)
							}
							{
								permission.enabled && (
									<label>
										<input type="checkbox" disabled={!editingSignal.value} checked={permission.enabled} />
										&nbsp;Enabled
									</label>
								)
							}
						</div>
					</td>
					<td style={{ width: '16%' }} >
						<div className='checkbox text-muted'>
							{
								permission.edit && (
									<label>
										<input type="checkbox" disabled={!editingSignal.value} checked={permission.edit} />
										&nbsp;Edit
									</label>
								)
							}
						</div>
					</td>
					<td style={{ width: '16%' }} >
						<div className='checkbox text-muted'>
							{
								permission.grant && (
									<label>
										<input type="checkbox" disabled={!editingSignal.value} checked={permission.grant} />
										&nbsp;Grant
									</label>
								)
							}
						</div>
					</td>
				</tr>
			)
		}
		return rows
	}

	const getApplicationGroupName = (appGroup) => {
		//window.alert("Unimplemented function getApplicationGroupName")
		switch (appGroup.id) {
			case 1:
				return appGroup.name
			default:
				return applicationGroupsSignal.value[0].name
		}
	}

	const selectAll = (appGroup) => {
		window.alert("Unimplemented function selectAll")
	}

	const selectNone = (appGroup) => {
		window.alert("Unimplemented function selectNone")
	}

	const saveRole = async () => {
		window.alert("Unimplemented function saveRole")
	}

	const ApplicationGroupRows = () => {
		let rows = []
		for (let i = 0; i < applicationGroupsSignal.value.length; i++) {
			const appGroup = applicationGroupsSignal.value[i]
			console.log("appGroup:")
			console.log(appGroup)
			rows.push(
				<Row className='row' key={appGroup.id}>
					<Col className="col-sm-1"></Col>
					<Col className="col-xs-12 col-sm-9 appGroup">
						<h4>{appGroup.name}</h4>
						{
							(roleSignal.value.isCustomRole && !editingSignal.value) ? (
								<div style={{ margin: "10px 0px 5px 0px" }}>
									<span style={{ marginRight: "10px" }}>
										<label onClick={() => { selectAll(appGroup) }}>All</label>
									</span>
									<span>
										<label onClick={() => { selectNone(appGroup) }}>None</label>
									</span>
								</div>
							) : <></>
						}

							<Table className="table table-responsive">
								<tbody className={editingSignal.value ? "editing" : "notEditing"}>
									<ApplicationGroupPermissionRows></ApplicationGroupPermissionRows>
								</tbody>
							</Table>
					</Col>
				</Row>
			)
		}
		return rows
	}

	return (
		<>
			<Breadcrumb className="px-3 pt-1 bg-light">
				<Breadcrumb.Item linkAs={Link} linkProps={{ to: `/be/${beId}/management/accounts` }}>Administration</Breadcrumb.Item>
				<Breadcrumb.Item linkAs={Link} linkProps={{ to: `/be/${beId}/management/roles` }}>Roles</Breadcrumb.Item>
				<Breadcrumb.Item active>{!roleLoadedSignal.value ? "Loading..." : roleSignal.value.name}</Breadcrumb.Item>
			</Breadcrumb>
			<PageTitle title='Roles' canEditSignal={canEditComputed} />
			<AdministrationTabs activeKey="3"></AdministrationTabs>
			{

				(!roleLoadedSignal.value || !applicationGroupsLoadedSignal.value || !rolePermissionsLoadedSignal.value) ? (
					<LoadingAnimation></LoadingAnimation>
				) : (
					<Form className="form-horizontal" role="form">
						<Container className="panel-body">
							<Row className="row" style={{ marginBottom: '20px' }} >
								<Col className="col-sm-1">
									<label className="control-label">Name</label>
								</Col>
								<Col className="col-sm-6">
									{
										roleSignal.value.isCustomRole ? (
											<input defaultValue={roleSignal.value.name} disabled={!editingSignal.value} className="form-control" size="50" maxLength="50" />
										) : (
											<input value={roleSignal.value.name} disabled="disabled" className="form-control" size="50" maxLength="50" />
										)
									}
								</Col>
								<Col className="col-sm-1">
									{
										(roleSignal.value.isCustomRole && userPermissionsSummary.value.canEditRoles && showEditSignal.value) ? (
											<label className="col-xs-2 edit-label control-label" onClick={showEditRoleModal}>Edit</label>
										) : <></>
									}
								</Col>
							</Row>
							{/*<ApplicationGroupRows />*/}
							<Table className="table table-responsive">
								<tbody className={editingSignal.value ? "editing" : "notEditing"}>
									<ApplicationGroupPermissionRows></ApplicationGroupPermissionRows>
								</tbody>
							</Table>
						</Container>
					</Form>
				)
			}
		</>
	)
}
export default RoleDetailPage